/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_AttributeDetailsGet } from '../models/Model_AttributeDetailsGet';
import type { Model_AttributeIdentityGet } from '../models/Model_AttributeIdentityGet';
import type { Model_ConfigurationAttributeGet } from '../models/Model_ConfigurationAttributeGet';
import type { Model_ConfigurationBulkPut } from '../models/Model_ConfigurationBulkPut';
import type { Model_ConfigurationGet } from '../models/Model_ConfigurationGet';
import type { Model_ConfigurationQueryFilterPost } from '../models/Model_ConfigurationQueryFilterPost';
import type { Model_ConfigurationsGet } from '../models/Model_ConfigurationsGet';
import type { Model_ConfiguratorOrderOut } from '../models/Model_ConfiguratorOrderOut';
import type { Model_ConfiguratorProductGet } from '../models/Model_ConfiguratorProductGet';
import type { Model_CustomerPortalPossibleCustomerGet } from '../models/Model_CustomerPortalPossibleCustomerGet';
import type { Model_ProjectExtendedGet } from '../models/Model_ProjectExtendedGet';
import type { Model_ProjectGet } from '../models/Model_ProjectGet';
import type { Model_ProjectProductsFilterPut } from '../models/Model_ProjectProductsFilterPut';
import type { Model_ProjectPut } from '../models/Model_ProjectPut';
import type { Model_SystemProductConfigurationGet } from '../models/Model_SystemProductConfigurationGet';
import type { Model_SystemProductConfigurationItemAttributePut } from '../models/Model_SystemProductConfigurationItemAttributePut';
import type { Model_SystemProductConfigurationItemAttributesGet } from '../models/Model_SystemProductConfigurationItemAttributesGet';
import type { Model_SystemProductConfigurationItemExtendedGet } from '../models/Model_SystemProductConfigurationItemExtendedGet';
import type { Model_SystemProductConfigurationItemPut } from '../models/Model_SystemProductConfigurationItemPut';
import type { Model_SystemProductConfigurationItemsBulkAttributePut } from '../models/Model_SystemProductConfigurationItemsBulkAttributePut';
import type { Model_SystemProductConfigurationItemsBulkCopyPut } from '../models/Model_SystemProductConfigurationItemsBulkCopyPut';
import type { Model_SystemProductConfigurationItemsBulkDeletePut } from '../models/Model_SystemProductConfigurationItemsBulkDeletePut';
import type { Model_SystemProductConfigurationPut } from '../models/Model_SystemProductConfigurationPut';
import type { Model_SystemProductConfigurationsBulkCopyPut } from '../models/Model_SystemProductConfigurationsBulkCopyPut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConfiguratorService {
    /**
     * @returns Model_ProjectGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjects(): CancelablePromise<Array<Model_ProjectGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects',
        });
    }
    /**
     * @param projectId
     * @returns Model_ProjectExtendedGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjects1(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ProjectExtendedGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * @param projectId
     * @param requestBody
     * @returns Model_ProjectExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorProjects(
        projectId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectPut>,
    ): CancelablePromise<Model_ProjectExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectId
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiV1ConfiguratorProjects(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/configurator/projects/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * @returns Model_AttributeDetailsGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorProjectsAttributes(): CancelablePromise<Array<Model_AttributeDetailsGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/projects/attributes',
        });
    }
    /**
     * @param projectId
     * @param requestBody
     * @returns Model_ConfiguratorProductGet Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorProjectsGetProducts(
        projectId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ProjectProductsFilterPut>,
    ): CancelablePromise<Array<Model_ConfiguratorProductGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/projects/getProducts/{projectId}',
            path: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param systemProductConfigurationItemId
     * @param requestBody
     * @returns Model_SystemProductConfigurationItemExtendedGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorSystemProductConfigurations(
        systemProductConfigurationItemId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationItemPut>,
    ): CancelablePromise<Model_SystemProductConfigurationItemExtendedGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/systemProductConfigurations/{systemProductConfigurationItemId}',
            path: {
                'systemProductConfigurationItemId': systemProductConfigurationItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param systemProductConfigurationItemId
     * @param requestBody
     * @returns Model_SystemProductConfigurationItemAttributesGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorSystemProductConfigurationsAttributes(
        systemProductConfigurationItemId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationItemAttributePut>,
    ): CancelablePromise<Array<Model_SystemProductConfigurationItemAttributesGet>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/systemProductConfigurations/attributes/{systemProductConfigurationItemId}',
            path: {
                'systemProductConfigurationItemId': systemProductConfigurationItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorSystemProductConfigurationsAttributes1(
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationItemsBulkAttributePut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/systemProductConfigurations/attributes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorSystemProductConfigurationsDelete(
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationItemsBulkDeletePut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/systemProductConfigurations/delete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorConfigurationDelete(
        requestBody?: ConvertDatesToStrings<Model_ConfigurationBulkPut>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/configuration/delete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param blankValues
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorSystemProductConfigurationItemCopy(
        blankValues?: ConvertDatesToStrings<boolean>,
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationItemsBulkCopyPut>,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/systemProductConfigurationItem/copy',
            query: {
                'blankValues': blankValues,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param blankValues
     * @param requestBody
     * @returns string Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorSystemProductConfigurationCopy(
        blankValues?: ConvertDatesToStrings<boolean>,
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationsBulkCopyPut>,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/systemProductConfiguration/copy',
            query: {
                'blankValues': blankValues,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param systemProductConfigurationItemId
     * @param parentLineItemId
     * @returns Model_AttributeIdentityGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorSystemProductConfigurationsMove(
        systemProductConfigurationItemId: ConvertDatesToStrings<string>,
        parentLineItemId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_AttributeIdentityGet>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/systemProductConfigurations/move/{systemProductConfigurationItemId}',
            path: {
                'systemProductConfigurationItemId': systemProductConfigurationItemId,
            },
            query: {
                'parentLineItemId': parentLineItemId,
            },
        });
    }
    /**
     * @param customerLoginOverrideId
     * @returns Model_CustomerPortalPossibleCustomerGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorCustomerList(
        customerLoginOverrideId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_CustomerPortalPossibleCustomerGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/customerList',
            query: {
                'customerLoginOverrideId': customerLoginOverrideId,
            },
        });
    }
    /**
     * @param projectId
     * @returns Model_ConfiguratorOrderOut Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateOrder(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfiguratorOrderOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateOrder/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * @param projectId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateOrderFile(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateOrderFile/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * @param projectId
     * @param systemProductConfigurationId
     * @returns Model_ConfiguratorOrderOut Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorGenerateConfigurationOrder(
        projectId: ConvertDatesToStrings<string>,
        systemProductConfigurationId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfiguratorOrderOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/generateConfigurationOrder/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'systemProductConfigurationId': systemProductConfigurationId,
            },
        });
    }
    /**
     * @param projectId
     * @param requestBody
     * @returns Model_ConfigurationsGet Success
     * @throws ApiError
     */
    public static postApiV1ConfiguratorConfigurations(
        projectId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_ConfigurationQueryFilterPost>,
    ): CancelablePromise<Model_ConfigurationsGet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurator/configurations/{projectId}',
            path: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param systemProductConfigurationId
     * @returns Model_ConfigurationGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorConfiguration(
        systemProductConfigurationId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_ConfigurationGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/configuration/{systemProductConfigurationId}',
            path: {
                'systemProductConfigurationId': systemProductConfigurationId,
            },
        });
    }
    /**
     * @param systemProductConfigurationId
     * @param requestBody
     * @returns Model_SystemProductConfigurationGet Success
     * @throws ApiError
     */
    public static putApiV1ConfiguratorConfiguration(
        systemProductConfigurationId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_SystemProductConfigurationPut>,
    ): CancelablePromise<Model_SystemProductConfigurationGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurator/configuration/{systemProductConfigurationId}',
            path: {
                'systemProductConfigurationId': systemProductConfigurationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param projectId
     * @returns Model_ConfigurationAttributeGet Success
     * @throws ApiError
     */
    public static getApiV1ConfiguratorConfigurationsAttributes(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_ConfigurationAttributeGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurator/configurations/attributes/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
}
